import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTourContext } from '../../contexts/TourContext';

const TourAutoStart: React.FC = () => {
  const location = useLocation();
  const { isActive, startTour, primeiroAcesso } = useTourContext();

  useEffect(() => {
    // ✅ AGUARDA CARREGAR primeiro_acesso DO BANCO
    if (primeiroAcesso === null) {
      return;
    }

    // ✅ ACEITA DASHBOARD OU INTEGRAÇÕES COMO PÁGINA DE INÍCIO
    const isOnDashboard = location.pathname === '/';
    const isOnIntegracoes = location.pathname === '/integracoes';
    const isValidStartPage = isOnDashboard || isOnIntegracoes;
    const tourNotActive = !isActive;
    const shouldStart = primeiroAcesso === true;

    if (isValidStartPage && tourNotActive && shouldStart) {
      const timer = setTimeout(() => {
        startTour(); // startTour já navega para a primeira página automaticamente
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [location.pathname, isActive, primeiroAcesso, startTour]);

  return null;
};

export default TourAutoStart;
